/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorCharges from './doctor-charges';
import DoctorChargesDetail from './doctor-charges-detail';
import DoctorChargesUpdate from './doctor-charges-update';
import DoctorChargesDeleteDialog from './doctor-charges-delete-dialog';

const DoctorChargesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorCharges />} />
    <Route path="new" element={<DoctorChargesUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorChargesDetail />} />
      <Route path="edit" element={<DoctorChargesUpdate />} />
      <Route path="delete" element={<DoctorChargesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorChargesRoutes;
